import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection, InspectionPlugin, Icons } from '../../shared/models/index';
import * as _ from 'lodash';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './parts.component.html',
    standalone: false
})
export class PartsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  public pointParts: any[];
  public inspectionPartsView: any[];
  inspectionId: string;
  pointId: string;
  public inspection: Inspection;

  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.plugin.config = this.inspection.parts != null ? this.inspection.parts.config : null;
    this.pointId = this.plugin.point != null && this.plugin.pluginType !== 'parts' ? this.plugin.point.id : -1;
    this.getPointParts();
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    if (this.plugin) {
      return [
        this.inspectionsRoute,
        this.inspection.id,
        'points',
        this.pointId,
        'plugins',
        this.plugin.id,
        'parts',
        'edit'
      ];
    }
  }

  getPointParts() {
    this.pointParts = this.hasConfig()
      ? _.filter(this.plugin.config.Parts, (p: any) => p.PointId === this.pointId)
      : [];
  }

  hasConfig(): Boolean {
    return this.plugin.config != null;
  }
}

PluginComponent.plugins['parts'] = PartsPluginComponent;
PluginComponent.plugins['pointparts'] = PartsPluginComponent;

PluginComponent.initializers['parts'] = (plugin: InspectionPlugin) => {
  if (plugin.config.PointParts) {
    for (const key in plugin.config.PointParts) {
      if (plugin.config.PointParts.hasOwnProperty(key) && plugin.config.PointParts[key]) {
        if (plugin.config.PointParts[key].NeedParts) {
          const part = plugin.config.PointParts[key];
          const point = plugin.inspection.pointsById[part.PointId];
          Icons.initIcon(point, Icons.getIconByName(Icons.requiredPartsIconName));
        }
      }
    }
  }

  if (plugin.config.Parts) {
    _.each(plugin.config.Parts, (part: any) => {
      const point = plugin.inspection.pointsById[part.PointId];
      Icons.initIcon(point, Icons.getIconByName(Icons.hasPartsIconName));
    });
  }
};
